import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  disabled = false, 
  className = '', 
  onClick,
  type = 'button',
  as: Component = 'button',
  light = false,
  ...props 
}) => {
  const baseClasses = light
    ? 'font-semibold rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed'
    : 'font-semibold rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#070b14] disabled:opacity-40 disabled:cursor-not-allowed';

  const darkVariants = {
    primary: 'bg-emerald-500 text-white hover:bg-emerald-400 focus:ring-emerald-500 shadow-lg shadow-emerald-500/10',
    secondary: 'bg-white/5 text-gray-300 hover:bg-white/10 hover:text-white focus:ring-emerald-500 border border-white/10',
    danger: 'bg-red-500/15 text-red-400 hover:bg-red-500/25 focus:ring-red-500 border border-red-500/20',
    success: 'bg-emerald-500/15 text-emerald-400 hover:bg-emerald-500/25 focus:ring-emerald-500 border border-emerald-500/20',
    warning: 'bg-amber-500/15 text-amber-400 hover:bg-amber-500/25 focus:ring-amber-500 border border-amber-500/20',
    outline: 'bg-white/5 text-gray-300 hover:bg-white/10 hover:text-white focus:ring-emerald-500 border border-white/10',
    ghost: 'text-gray-400 hover:bg-white/5 hover:text-white focus:ring-emerald-500'
  };

  const lightVariants = {
    primary: 'bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500 shadow-sm',
    secondary: 'bg-gray-100 text-gray-900 hover:bg-gray-200 focus:ring-gray-500 border border-gray-300',
    danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500',
    success: 'bg-green-600 text-white hover:bg-green-700 focus:ring-green-500',
    warning: 'bg-amber-500 text-white hover:bg-amber-600 focus:ring-amber-500',
    outline: 'border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:ring-blue-500',
    ghost: 'text-gray-700 hover:bg-gray-100 focus:ring-blue-500'
  };

  const variants = light ? lightVariants : darkVariants;

  const sizes = {
    sm: 'px-3 py-1.5 text-xs',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-2.5 text-base',
    xl: 'px-8 py-3 text-lg'
  };
  
  const classes = `${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`;
  
  if (Component === Link) {
    return (
      <Link className={classes} {...props}>
        {children}
      </Link>
    );
  }
  
  return (
    <Component
      type={type}
      className={classes}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </Component>
  );
};

export default Button;
